import { render } from "./DrugstoresProductsLocalDataList.vue?vue&type=template&id=1d670376&scoped=true"
import script from "./DrugstoresProductsLocalDataList.vue?vue&type=script&lang=js"
export * from "./DrugstoresProductsLocalDataList.vue?vue&type=script&lang=js"

import "./DrugstoresProductsLocalDataList.vue?vue&type=style&index=0&id=1d670376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d670376"]])

export default __exports__